import { render } from "./DetailsLesson.vue?vue&type=template&id=73fce217&scoped=true"
import script from "./DetailsLesson.vue?vue&type=script&lang=js"
export * from "./DetailsLesson.vue?vue&type=script&lang=js"

import "./DetailsLesson.vue?vue&type=style&index=0&id=73fce217&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\projetos\\ethos-plataforma-ead\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73fce217"]])

export default __exports__